require("./sf-pro.scss");
module.exports = "SFPro";


// WEBPACK FOOTER //
// ./Sig.Web/src/common/com-webfont/sf-pro/sf-pro.js